module.exports = __webpack_public_path__ + "svg-sprite.06d08845.svg";


//////////////////
// WEBPACK FOOTER
// /var/www/build-lk-1/public/assets/img/svg-sprite.svg
// module id = 460
// module chunks = 0